import axios from "axios";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";
import { ACCESSORIES_PRICING_URL } from "../utils/EmpUtil";
import { is401 } from "../errors/ErrorConstants";

class NamePlateSettingsClient {
  static baseUrl = ACCESSORIES_PRICING_URL;

  static getDealerNamePlateAdjustments(user, catalogId) {
    const url = `${
      this.baseUrl
    }/accessories/nameplate-settings?dealerCommonId=${user.getEncodedCommonId()}&catalogId=${catalogId}`;

    return axios
      .get(url)
      .then((response) => {
        return response.data.result.namePlateCategoryGroup;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getAllVehicleLines(user, brand) {
    const url = `${this.baseUrl}/accessories/nameplate-settings/vehicleLines?brand=${brand}`;

    return axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveDealerBrandAdjustments(
    user,
    catalogId,
    data,
    modifiedLaborRate,
    modifiedMarkup
  ) {
    const url = `${
      this.baseUrl
    }/accessories/nameplate-settings/save?dealerCommonId=${user.getCommonIds()}&catalogId=${catalogId}&modifiedLaborRate=${modifiedLaborRate}&modifiedMarkup=${modifiedMarkup}`;
    return axios
      .post(url, data)
      .then(() => {
        return Promise.resolve(true);
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}

export default NamePlateSettingsClient;
